import { useContext, Context } from 'react';
import { ThemeContext } from 'styled-components';
import { ThemeType } from './Styles/ThemeType';

export function useStyledTheme() {
  return useContext<ThemeType>(ThemeContext as Context<ThemeType>);
}
